/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Index_LoadingInputs */

const id_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const ms_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const da_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser...`)
};

const de_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lädt...`)
};

const en_us2_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const es_es2_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const es_mx2_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const fil_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naglo-load...`)
};

const fr_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const it_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

const hu_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betöltés...`)
};

const nl_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden...`)
};

const no_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster...`)
};

const pl_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ładowanie...`)
};

const pt_br2_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

const pt_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar...`)
};

const ro_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se încarcă...`)
};

const fi_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan...`)
};

const sv_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar...`)
};

const vi_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải...`)
};

const tr_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor...`)
};

const cs_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání...`)
};

const bg_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зареждане...`)
};

const ru_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const uk_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження...`)
};

const ar_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل...`)
};

const hi_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोड हो रहा है...`)
};

const th_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลด...`)
};

const ja_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中...`)
};

const zh_cn2_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中...`)
};

const zh_hant1_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入中...`)
};

const ko_changelog_index_loading = /** @type {(inputs: Changelog_Index_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩 중...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Changelog_Index_LoadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const changelog_index_loading = /** @type {((inputs?: Changelog_Index_LoadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Index_LoadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_changelog_index_loading(inputs)
	if (locale === "ms") return ms_changelog_index_loading(inputs)
	if (locale === "da") return da_changelog_index_loading(inputs)
	if (locale === "de") return de_changelog_index_loading(inputs)
	if (locale === "en-US") return en_us2_changelog_index_loading(inputs)
	if (locale === "es-ES") return es_es2_changelog_index_loading(inputs)
	if (locale === "es-MX") return es_mx2_changelog_index_loading(inputs)
	if (locale === "fil") return fil_changelog_index_loading(inputs)
	if (locale === "fr") return fr_changelog_index_loading(inputs)
	if (locale === "it") return it_changelog_index_loading(inputs)
	if (locale === "hu") return hu_changelog_index_loading(inputs)
	if (locale === "nl") return nl_changelog_index_loading(inputs)
	if (locale === "no") return no_changelog_index_loading(inputs)
	if (locale === "pl") return pl_changelog_index_loading(inputs)
	if (locale === "pt-BR") return pt_br2_changelog_index_loading(inputs)
	if (locale === "pt") return pt_changelog_index_loading(inputs)
	if (locale === "ro") return ro_changelog_index_loading(inputs)
	if (locale === "fi") return fi_changelog_index_loading(inputs)
	if (locale === "sv") return sv_changelog_index_loading(inputs)
	if (locale === "vi") return vi_changelog_index_loading(inputs)
	if (locale === "tr") return tr_changelog_index_loading(inputs)
	if (locale === "cs") return cs_changelog_index_loading(inputs)
	if (locale === "bg") return bg_changelog_index_loading(inputs)
	if (locale === "ru") return ru_changelog_index_loading(inputs)
	if (locale === "uk") return uk_changelog_index_loading(inputs)
	if (locale === "ar") return ar_changelog_index_loading(inputs)
	if (locale === "hi") return hi_changelog_index_loading(inputs)
	if (locale === "th") return th_changelog_index_loading(inputs)
	if (locale === "ja") return ja_changelog_index_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_changelog_index_loading(inputs)
	if (locale === "zh-Hant") return zh_hant1_changelog_index_loading(inputs)
	return ko_changelog_index_loading(inputs)
});
export { changelog_index_loading as "changelog.index.loading" }